import { useMutation } from '@tanstack/react-query';

import { ZoneFormSchemaValues } from 'src/features/zone/utils/formSchema';
import { Zone } from 'src/features/zone/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/zone/:zoneId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: ZoneFormSchemaValues;
    zoneId: string;
    parkingId: string;
}
const mutationFn = ({ zoneId, parkingId, data }: DTO): Promise<Zone> => {
    return axios.put(formatResourcePath(RESOURCE, { zoneId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateZone };
